<template>
    <v-main id="onMltt">
        <v-container fluid v-if="!loading">
            <v-card flat>
                <v-card-title class="justify-center">{{ mltp.mltp_nr }} - {{ mltp.mltp_oms }}</v-card-title>
                <v-divider></v-divider>
                <v-simple-table dense>
                    <thead>
                        <tr>
                            <th width="10%">Language</th>
                            <th width="10%">Type</th>
                            <th width="25%">Subject</th>
                            <th width="35%">Text</th>
                            <th width="20%">Actions</th>
                        </tr>
                    </thead>
                    <tbody v-for="(mlttRecord, i) in mltp.mltt" :key="i">
                        <tr>
                            <td>{{ mlttRecord.taal_code }}</td>
                            <td>{{ mlttRecord.mltt_type }}</td>
                            <td><longTextView :long_text="mlttRecord.mltt_subject" :max_width="400"/></td>
                            <td><longTextView :long_text="mlttRecord.mltt_txt" :max_width="600" :disableTooltip="true"/></td>
                            <td>
                                <v-btn class="primary mr-2 my-2" small @click="editMltt(mlttRecord)">Edit</v-btn>
                                <v-btn class="primary mr-2 my-2" small @click="previewMltt(mlttRecord)">Preview</v-btn>
                                <v-btn class="primary mr-2 my-2" small @click="copyMltt(mlttRecord)">{{ mlttRecord.mltt_type_ander }}</v-btn>
                            </td>
                        </tr>  
                    </tbody>  
                </v-simple-table>
            </v-card>  
        </v-container>
        <navBar title="Ares - Mail templates" :home="true" type="mltp"/> 
        <updMltt ref="updMltt"/>
    </v-main>
</template>

<script>
    import navBar from "@/components/ui/navbars/navbar.vue"
    import longTextView from "@/components/ui/fields/longTextView.vue";
    import updMltt from '@/components/syst/mltp/updMltt.vue';
    
    export default {
        components: {
            navBar,
            longTextView,
            updMltt,
        },
        props: {
            mltt_encrid: {
                type: String,
                required: true,
            },
        },
        data() {
            return {
                loading: true,
                mltp: {}
            }  
        },
        mounted() {
            this.getMltt();
        },
        methods: {
            getMltt() {
                this.loading = true;
                this.$axios.post("ares/json/ares/syst/mltp/getMltt.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "getMltt"
                    },
                    getMltt: {
                        mltt_encrid: this.mltt_encrid
                    }
                }).then(res => {
                    if (res.data.error) {
                        console.log(res.data.error);
                    } else {
                        this.mltp = res.data.getMltt;
                    }
                }).finally(() => {
                    this.loading = false;
                });
            },
            copyMltt(mltt) { 
                this.$axios.post("ares/json/ares/syst/mltp/copyMltt.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "copyMltt"
                    },
                    copyMltt: {
                        mltt: mltt
                    }
                }).then(res => {
                    if (res.data.error) {
                        console.log(res.data.error);
                    } else {
                        this.$store.dispatch('setSnackbar', {
                            showing: true,
                            text: res.data.copyMltt.text,
                            color: res.data.copyMltt.color
                        });
                        this.getMltt();  
                    }
                })
            },
            editMltt(mltt) {
                this.$refs.updMltt.openDialog(this.mltp, mltt);
            },
            previewMltt(mltt) {
                this.$axios.post("ares/json/ares/syst/mltp/previewMltt.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "previewMltt"
                    },
                    previewMltt: {
                        mltt_encrid: mltt.mltt_encrid,
                    }
                }).then(res => {
                    if (res.data.error) {
                        console.log(res.data.error);
                        this.$store.dispatch('setSnackbar', {
                            showing: true,
                            text: res.data.error.message,
                            color: "error"
                        });
                    } else {
                        window.open(res.data.previewMltt, '_blank');  
                    }
                })
            },
            actionClick() {
            },        
        },
    };

</script> 
